import type { Checklist } from '@cognite/apm-client';

export const extractChecklistItemsFromChecklist = (checklist?: Checklist) => {
  return checklist?.checklistItems ?? [];
};
